<template>
  <div id="page" class="step-form">
    <Header />
    <main class="main main-form">
      <form class="section-form icw-form" method="POST">
        <div class="section-progressbar">
          <div class="container">
            <ul class="bar-step">
              <li
                class="active"
                :onclick="'window.location.href=\'' + info + '\''"
              >
                ข้อมูลส่วนตัว
              </li>
              <li>การเงิน</li>
              <li>สุขภาพ</li>
              <li>ผลประเมิน</li>
            </ul>
            <ul class="bar-list" id="progressbar">
              <li
                v-for="(v, i) in ProgressLength"
                :key="i"
                :class="{ active: currentStep >= v }"
              ></li>
            </ul>
          </div>
        </div>
        <div class="section-fieldset">
          <div class="section-fieldset-wrapper">
            <div class="section-fieldset-inner">
              <div class="container">
                <div class="fieldset-group">
                  <Q1 :QuestionType="'Information'" />
                  <!-- Information -->
                  <Q2 :QuestionType="'Job'" />
                  <!-- Job -->
                  <Q3 :QuestionType="'Contact'" />
                  <!-- Contact -->
                  <Q4 :QuestionType="'Profile'" />
                  <!-- Profile -->
                  <Q5 :QuestionType="'Income'" />
                  <!-- Income -->
                  <Q6 :QuestionType="'LifeStyle'" />
                  <!-- LifeStyle -->
                  <Q7 :QuestionType="'Healthy'" />
                  <!-- Healthy -->
                  <!-- Check Step3-Q2 Step3-Q3 -->
                  <Q8 :QuestionType="'LifestyleGadget'" />
                  <!-- Lifestyle GadGet-->
                  <Q9 :QuestionType="'HealthyActivities'" />
                  <!-- Healthy Activities -->
                  <Q10 :QuestionType="'RunActivities'" />
                  <!-- Run Activities -->
                  <Q11 :QuestionType="'BikeActivities'" />
                  <!-- Bike Activities -->
                </div>
              </div>
            </div>
          </div>
          <div class="section-fieldset-button"></div>
        </div>
      </form>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import jQuery from "jquery";

import MyConfig from "@/../me.config.js";

import { getCurrentStep, my_range } from "@/helpers/global_helper.js";

import Header from "@/components/Header.vue";

import axios from "axios";
import VueAxios from "vue-axios";

import Q1 from "@/components/QuestionStep1/STEP1-Q1.vue";
import Q2 from "@/components/QuestionStep1/STEP1-Q2.vue";
import Q3 from "@/components/QuestionStep1/STEP1-Q3.vue";
import Q4 from "@/components/QuestionStep1/STEP1-Q4.vue";
import Q5 from "@/components/QuestionStep1/STEP1-Q5.vue";
import Q6 from "@/components/QuestionStep1/STEP1-Q6.vue";
import Q7 from "@/components/QuestionStep1/STEP1-Q7.vue";
import Q8 from "@/components/QuestionStep1/STEP1-Q8.vue";
import Q9 from "@/components/QuestionStep1/STEP1-Q9.vue";
import Q10 from "@/components/QuestionStep1/STEP1-Q10.vue";
import Q11 from "@/components/QuestionStep1/STEP1-Q11.vue";

Vue.use(VueAxios, axios);
window.jQuery = window.$ = jQuery;

require("@/assets/theme/js/library/jquery.easing.1.3.min.js");
require("@/assets/theme/plugin/magnific-popup/jquery.magnific-popup.js");

require("@/assets/theme/plugin/bootstrap/bootstrap.min.js");

Vue.mixin({
  data: function() {
    return {
      isError: false,
      wrongFormat: false
    };
  }
});

export default {
  name: "Step1",
  mounted() {
    this.$nextTick(() => {
      require("@/assets/theme/js/theme.js");

      sessionStorage.removeItem("userEmail");
    });

    let api_url = MyConfig.API_PATH;
    let _campaign = typeof window._site_params !== "undefined" ? window._site_params.campaign : "";
    sessionStorage.setItem("_campaignPath", _campaign);
    this.axios
      .post(
        api_url + "/api/get_campaign",
        $.param({
          _campaign: _campaign,
        }),
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      )
      .then(function(res) {
        if (res.data.response == "success") {
          if (sessionStorage.getItem("salecode_button")) {
            sessionStorage.removeItem("salecode_button");
          }

          if (sessionStorage.getItem("share_button")) {
            sessionStorage.removeItem("share_button");
          }

          sessionStorage.setItem(
            "salecode_button",
            res.data.result[0].salecode_button
          );
          sessionStorage.setItem("share_button", res.data.result[0].share_button);
        } else {
          if (sessionStorage.getItem("salecode_button")) {
            sessionStorage.removeItem("salecode_button");
          }

          if (sessionStorage.getItem("share_button")) {
            sessionStorage.removeItem("share_button");
          }
        }
      })
      .catch(function(err) {
        // console.log(err);

        if (sessionStorage.getItem("salecode_button")) {
          sessionStorage.removeItem("salecode_button");
        }

        if (sessionStorage.getItem("share_button")) {
          sessionStorage.removeItem("share_button");
        }
      });

    if (sessionStorage.getItem("question_result")) {
      sessionStorage.removeItem("question_result");
    }
  },
  components: {
    Header,
    Q1,
    Q2,
    Q3,
    Q4,
    Q5,
    Q6,
    Q7,
    Q8,
    Q9,
    Q10,
    Q11
  },
  data() {
    return {
      currentStep: getCurrentStep("step1"),
      ProgressLength: my_range(1, 11),
      info: MyConfig.InfoPath,
      wealth: MyConfig.WealthPath,
      health: MyConfig.HealthPath
    };
  },
  methods: {
    GoTo(step) {
      return this.$router.push(step);
    }
  },
  watch: {
    currentStep: function(n, o) {
      this.ProgressLength = my_range(1, 11);
    }
  }
};
</script>
